import { Link } from 'react-router-dom';
import { ExternalLink, HelpCircle } from 'lucide-react';
import { generateFAQStructuredData } from '../utils/structuredData';

export function Footer() {
  // FAQ data for the site
  const faqData = [
    {
      question: "Vad är SOKASTIFTELSEMEDEL.SE?",
      answer: "SOKASTIFTELSEMEDEL.SE är en söktjänst som hjälper dig hitta stiftelser i Sverige som passar ditt ändamål. Vi samlar information från över 17 000 stiftelser för att göra din sökprocess enklare och effektivare."
    },
    {
      question: "Är det gratis att använda tjänsten?",
      answer: "Grundläggande sökning är kostnadsfri. Vi erbjuder även premiumtjänster med avancerade sökfunktioner, AI-stöd och specialverktyg för att maximera dina chanser att hitta rätt stiftelser."
    },
    {
      question: "Hur aktuell är informationen?",
      answer: "Vi uppdaterar regelbundet vår databas med information från officiella källor. Dock rekommenderar vi alltid att du verifierar informationen direkt med stiftelsen innan du skickar in en ansökan."
    },
    {
      question: "Kan jag söka stiftelsemedel via er webbplats?",
      answer: "Nej, vi förmedlar endast information om stiftelser. Ansökningar måste skickas direkt till respektive stiftelse enligt deras specifika ansökningsprocess."
    }
  ];

  // Generate structured data for FAQ
  const faqStructuredData = generateFAQStructuredData(faqData);
  
  return (
    <footer className="bg-[#A3C1DA] text-white" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
          <div>
            <h3 className="text-lg font-semibold mb-3">Om SOKASTIFTELSEMEDEL.SE</h3>
            <p className="text-white/80 text-sm">
              Ett verktyg som hjälper dig att hitta stiftelser i Sverige som passar ditt ändamål. 
              Vi samlar information från över 17 000 stiftelser för att göra din sökprocess enklare.
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-3">Länkar</h3>
            <ul className="space-y-2 text-white/80 text-sm">
              <li>
                <Link to="/" className="hover:text-white transition-colors">Hem</Link>
              </li>
              <li>
                <Link to="/allt-om-stiftelser" className="hover:text-white transition-colors">Läsvärt om Stiftelser</Link>
              </li>
              <li>
                <Link to="/blogg" className="hover:text-white transition-colors">Stiftelse Nyheter</Link>
              </li>
              <li>
                <Link to="/premium" className="hover:text-white transition-colors">Ansökningshjälpen AI</Link>
              </li>
              <li>
                <Link to="/projektborsen" className="hover:text-white transition-colors">Projektbörsen</Link>
              </li>
              <li>
                <Link to="/starta-stiftelse" className="hover:text-white transition-colors">Starta stiftelse</Link>
              </li>
              <li>
                <Link to="/vanliga-fragor" className="hover:text-white transition-colors">Vanliga frågor (FAQ)</Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-3">Juridisk information</h3>
            <ul className="space-y-2 text-white/80 text-sm">
              <li>
                <Link to="/integritetspolicy" className="hover:text-white transition-colors">Integritetspolicy</Link>
              </li>
              <li>
                <Link to="/betalningsinformation" className="hover:text-white transition-colors">Prissättning och betalning</Link>
              </li>
              <li>
                <a
                  href="https://stiftelser.lansstyrelsen.se/Öppendata"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors inline-flex items-center gap-1"
                >
                  Datakälla
                  <ExternalLink className="w-3 h-3" />
                </a>
              </li>
            </ul>
          </div>
          
          {/* Hidden FAQ structured data for SEO */}
          <div className="hidden" itemScope itemType="https://schema.org/FAQPage">
            <script type="application/ld+json">
              {JSON.stringify(faqStructuredData)}
            </script>
            
            {faqData.map((faq, index) => (
              <div key={index} itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
                <h4 itemProp="name">{faq.question}</h4>
                <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                  <p itemProp="text">{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="border-t border-white/20 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/80 text-sm">
            © {new Date().getFullYear()} SOKASTIFTELSEMEDEL.SE - Alla rättigheter förbehållna
          </p>
          <div className="flex items-center gap-2 text-white/80 text-sm">
            <span>Utvecklad av:</span>
            <a 
              href="https://heimlandr.io" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="inline-flex items-center gap-1 text-[#F2C1D1] hover:text-[#F3E5AB] font-semibold transition-colors group"
            >
              WWW.HEIMLANDR.IO
              <ExternalLink className="w-3 h-3 opacity-50 group-hover:opacity-100 transition-opacity" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
